export default {"src":"/_next/static/media/WT.94ecf855.svg","height":18,"width":18};